exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".NewAdressRequest_component_3zth {\n  margin-bottom: 20px;\n\n  width: 100%;\n  max-width: none;\n\n  text-align: left\n}\n\n.NewAdressRequest_component_3zth:last-child {\n  margin-bottom: 0;\n}\n\n.NewAdressRequest_row_OwyY + .NewAdressRequest_row_OwyY {\n  margin-top: 25px;\n}\n\n.NewAdressRequest_checkbox_248y > span {\n  top: 3px;\n}\n\n.NewAdressRequest_input_3Nia {\n  margin-right: 20px;\n\n  display: inline-block;\n\n  max-width: 200px;\n}\n\n.NewAdressRequest_errorLabel_3TtN {\n  color: #dc0000;\n}\n", ""]);

// exports
exports.locals = {
	"component": "NewAdressRequest_component_3zth",
	"row": "NewAdressRequest_row_OwyY",
	"checkbox": "NewAdressRequest_checkbox_248y",
	"input": "NewAdressRequest_input_3Nia",
	"errorLabel": "NewAdressRequest_errorLabel_3TtN"
};